import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import '../../plugins/axios'
import { AUTH_LOGOUT } from '../actions/auth'
import store from '../../store'

const state = { status: '', profile: {} };

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username,
};


const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST);
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/auth/me',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
      };
      axios(config)
        .then(resp => {
          commit(USER_SUCCESS, resp.data);
          if (resp.data && (resp.data.roll === 15 || resp.data.roll === 11)) {
            dispatch('FETCH_SHIPMENTS_ACCESS').catch(() => { });
            dispatch('FETCH_PROVIDER_PARKING_MODULE').catch(() => { });
          }
          const profile = resp.data
          const hasParking = profile && (
            profile.enable_parking === true ||
            (profile.empresa && profile.empresa.enable_parking === true)
          )
          if (profile && profile.roll === 2 && hasParking) {
            dispatch('CONNECT_WS').catch(() => { });
          }
          resolve(resp.data);
        })
        .catch(resp => {
          commit(USER_ERROR);
          dispatch(AUTH_LOGOUT);
          reject(resp);
        })
    });
  },
};

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'profile', resp);
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
}
